import { queryOptions } from '@tanstack/react-query';

import { ApiService } from '@/services/api-v2';

export const workspaceKeys = {
  all: ['workspace'] as const,
  detail: (workspaceId: string | null | undefined) => [...workspaceKeys.all, workspaceId] as const,
};

export const getWorkspaceQueryOptions = ({ workspaceId }: { workspaceId: string | null | undefined }) => {
  return queryOptions({
    queryKey: workspaceKeys.detail(workspaceId),
    queryFn: async () => {
      if (!workspaceId) {
        throw new Error('Workspace ID is required');
      }
      const { workspace } = await (await ApiService.GetWorkspaceById({ workspaceId })).json();
      return workspace;
    },
    enabled: !!workspaceId,
  });
};
